module.exports = __webpack_public_path__ + "c_static/img/A1-4-1旺旺号.60002f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/完善资料/A1-4-1旺旺号.jpg
// module id = Oawn
// module chunks = 33